import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgTextBalloon = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g>
      <g>
        <path d='M5.5 8.5H18.5V9.5H5.5V8.5Z' />
        <path d='M15.5 11.5H10.5V12.5H15.5V11.5Z' />
        <path d='M5.5 11.5H8.5V12.5H5.5V11.5Z' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M23 4C23 3.2 22.3 2.5 21.5 2.5H2.5C1.7 2.5 1 3.2 1 4V15C1 15.8 1.7 16.5 2.5 16.5H5.5V21.5L10.5 16.5H21.5C22.3 16.5 23 15.8 23 15V4ZM6.5 15.5V19.1L10.1 15.5H21.5C21.8 15.5 22 15.3 22 15V4C22 3.7 21.8 3.5 21.5 3.5H2.5C2.2 3.5 2 3.7 2 4V15C2 15.3 2.2 15.5 2.5 15.5H6.5Z'
        />
      </g>
    </g>
  </svg>
);
export default SvgTextBalloon;
